import { Box, Link as MaterialLink, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";

interface TermsContentProps {
  size?: "default" | "compact";
}

export default function TermsContent({ size = "default" }: TermsContentProps) {
  const { t } = useTranslation();
  const section3p4 = t("termsPage.section3.p4", { defaultValue: "" });
  const section3p5 = t("termsPage.section3.p5", { defaultValue: "" });
  const section3p6 = t("termsPage.section3.p6", { defaultValue: "" });

  const headingVariant = size === "compact" ? "h6" : "h4";
  const subheadingVariant = size === "compact" ? "subtitle1" : "h5";
  const bodyVariant = size === "compact" ? "body2" : "body1";
  const gap = size === "compact" ? 1.5 : 2.5;

  return (
    <Box display="flex" flexDirection="column" gap={gap} sx={{ width: "100%" }}>
      <Typography component="h2" variant={headingVariant} color="text.primary" sx={{ textAlign: "left" }}>
        {t("termsPage.heading")}
      </Typography>
      <Typography component="h2" variant={subheadingVariant} color="text.primary" sx={{ textAlign: "left" }}>
        {t("termsPage.lastUpdated")}
      </Typography>

      <Typography component="h3" variant={subheadingVariant} color="text.primary" sx={{ textAlign: "left" }}>
        {t("termsPage.section1.title")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section1.p1")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section1.p2")}
      </Typography>

      <Typography component="h3" variant={subheadingVariant} color="text.primary" sx={{ textAlign: "left" }}>
        {t("termsPage.section2.title")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section2.p1")}
      </Typography>

      <Typography component="h3" variant={subheadingVariant} color="text.primary" sx={{ textAlign: "left" }}>
        {t("termsPage.section3.title")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section3.p1")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section3.p2")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section3.p3")}
      </Typography>
      {section3p4 && (
        <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
          {section3p4}
        </Typography>
      )}
      {section3p5 && (
        <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
          {section3p5}
        </Typography>
      )}
      {section3p6 && (
        <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
          {section3p6}
        </Typography>
      )}

      <Typography component="h3" variant={subheadingVariant} color="text.primary" sx={{ textAlign: "left" }}>
        {t("termsPage.section4.title")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section4.p1")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section4.p2")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section4.p3")}
      </Typography>

      <Typography component="h3" variant={subheadingVariant} color="text.primary" sx={{ textAlign: "left" }}>
        {t("termsPage.section5.title")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section5.p1")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section5.p2")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section5.p3")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section5.refundPrefix")}{" "}
        <MaterialLink color="text.primary" component={RouterLink} to="mailto:support@bigswiss.ch">
          support@bigswiss.ch
        </MaterialLink>{" "}
        {t("termsPage.section5.refundSuffix")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section5.cancellationPrefix")}{" "}
        <MaterialLink color="text.primary" component={RouterLink} to="mailto:support@bigswiss.ch">
          support@bigswiss.ch
        </MaterialLink>{" "}
        {t("termsPage.section5.cancellationSuffix")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section5.p6")}
      </Typography>

      <Typography component="h3" variant={subheadingVariant} color="text.primary" sx={{ textAlign: "left" }}>
        {t("termsPage.section6.title")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section6.p1")}
      </Typography>

      <Typography component="h3" variant={subheadingVariant} color="text.primary" sx={{ textAlign: "left" }}>
        {t("termsPage.section7.title")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section7.p1")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section7.p2")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section7.p3")}
      </Typography>

      <Typography component="h3" variant={subheadingVariant} color="text.primary" sx={{ textAlign: "left" }}>
        {t("termsPage.section8.title")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section8.p1")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section8.p2")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section8.p3")}
      </Typography>

      <Typography component="h3" variant={subheadingVariant} color="text.primary" sx={{ textAlign: "left" }}>
        {t("termsPage.section9.title")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section9.p1")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section9.p2")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section9.p3")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section9.p4")}
      </Typography>

      <Typography component="h3" variant={subheadingVariant} color="text.primary" sx={{ textAlign: "left" }}>
        {t("termsPage.section10.title")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section10.p1")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section10.p2")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section10.p3")}
      </Typography>

      <Typography component="h3" variant={subheadingVariant} color="text.primary" sx={{ textAlign: "left" }}>
        {t("termsPage.section11.title")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section11.p1")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section11.p2")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section11.p3")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section11.p4")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section11.p5")}
      </Typography>

      <Typography component="h3" variant={subheadingVariant} color="text.primary" sx={{ textAlign: "left" }}>
        {t("termsPage.section12.title")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section12.p1")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section12.p2")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section12.p3")}
      </Typography>

      <Typography component="h3" variant={subheadingVariant} color="text.primary" sx={{ textAlign: "left" }}>
        {t("termsPage.section13.title")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section13.p1")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section13.p2")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section13.p3")}{" "}
        <MaterialLink color="text.primary" component={RouterLink} to="mailto:support@bigswiss.ch">
          support@bigswiss.ch
        </MaterialLink>{" "}
        {t("termsPage.section13.emailNote")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section13.p4")}
      </Typography>
      <Typography variant={bodyVariant} color="text.secondary" sx={{ textAlign: "left" }}>
        {t("termsPage.section13.p5")}
      </Typography>
    </Box>
  );
}
